(function(){
  function apply(){
    var h=document.querySelector('h1');
    var title=(h?h.textContent:'').trim();
    if(!title)return;
    var medias=document.querySelectorAll('.product-media[data-media-id]');
    if(medias.length<2)return;
    var nonGen=[],gen=[];
    for(var i=0;i<medias.length;i++){
      var m=medias[i];var img=m.querySelector('img');
      var alt=(img&&img.getAttribute('alt')||'').trim();
      var cp=alt.split(title).join('').trim();
      if(cp==='')gen.push(m);else nonGen.push(m);
    }
    var show=nonGen.length?nonGen:gen;
    if(!show.length)return;
    for(var j=0;j<medias.length;j++){
      var mm=medias[j];
      var slot=mm.closest('slideshow-slide')||mm.closest('li')||mm;
      var want=(show.indexOf(mm)>-1)?'':'none';
      if(slot.style.display!==want)slot.style.display=want;
    }
  }
  function burst(){apply();setTimeout(apply,120);setTimeout(apply,400);setTimeout(apply,900);}
  if(document.readyState!=='loading')burst();else document.addEventListener('DOMContentLoaded',burst);
  document.addEventListener('shopify:section:load',burst);
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-picker'))burst();},true);
  document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-picker'))burst();},true);
  setInterval(apply,700);
})();